import axios from 'axios'
export default{
   getArticleTypeList(){
    return axios.get("/api/articletype/");
   }
}